import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Axios from 'axios';
import { AcervoAPI, VinculosAPI } from '../../../../shared/http-requests';
import { connect } from 'react-redux';
import BaseTemplate from '../template/BaseTemplate';
import ContentDetails from '../../components/ContentDetails';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import DadosAcervoPrincipal from '../../components/DadosAcervo/DadosAcervoPrincipal';
import { useTranslation } from 'react-i18next';

const DadosAcervoBiblioteca = ({
    statusRx,
    guiasPesquisaRx,
    ultimoLogRx,
}) => {
    const { codAcervo } = useParams();
    const [images, setImages] = useState(null);
    const [loadingImages, setLoadingImages] = useState(true);
    const [loadingData, setLoadingData] = useState(true);
    const [collectionData, setCollectionData] = useState(null);

    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            const cancelToken = Axios.CancelToken.source();
            setLoadingData(prevState => prevState === false);
            try {
                const response = await AcervoAPI.buscarDadosAcervo(
                    codAcervo,
                    cancelToken.token,
                );
                if (response) {
                    const { data } = response;
                    if (data) {
                        setCollectionData(data);
                    }
                }
                setLoadingData(prevState => prevState === true);
            } catch (e) {
                if (!Axios.isCancel(e)) {
                    setLoadingData(prevState => prevState === true);
                    setCollectionData(null);
                }
            }
            return () => cancelToken.cancel();
        })();
    }, [codAcervo]);

    useEffect(() => {
        const cancelToken = Axios.CancelToken.source();
        if (statusRx) {
            setLoadingImages(true);
            VinculosAPI.buscarImagensAcervo(codAcervo, 0, cancelToken.token)
                .then(response => {
                    setImages(
                        response.data.map(({ conteudo }) => ({
                            src: conteudo,
                        })),
                    );
                    setLoadingImages(false);
                })
                .catch(error => {
                    if (!Axios.isCancel(error)) {
                        setImages(null);
                        setLoadingImages(false);
                    }
                });
        }
        //? cleanup
        return () => cancelToken.cancel();
    }, [codAcervo, statusRx]);

    const getGuiaPesquisa = useMemo(() => {
        if (ultimoLogRx) return ultimoLogRx.pesquisa;

        if (guiasPesquisaRx?.length)
            return guiasPesquisaRx.find(guia => guia.ordem === 0).codigo;
        else return '';
    }, [guiasPesquisaRx, ultimoLogRx]);

    const handleClickGoBack = () => {
        navigate(-1)
    };


    return (
        <BaseTemplate guiaSelecionada={getGuiaPesquisa} extras={false}>
            <div className="app tema-pergamum consultaContent col-md-12 pad5 bkbranco">
                <ContentDetails
                    loadingCarousel={loadingImages}
                    onClickGoBack={handleClickGoBack}
                    images={images}
                    title={t('DadosUnidadeInformacao')}
                >
                    {loadingData ? (
                        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                            <FontAwesomeIcon
                                spin
                                size="2x"
                                className="cortxt"
                                icon={faSpinner}
                            />
                        </div>
                    ) : collectionData !== null ? (
                        <DadosAcervoPrincipal
                            viewModeBiblioteca={true}
                            dados={collectionData}
                            codAcervo={codAcervo}
                        />
                    ) : (
                        <p>{t('AcervoBibliotecaSemDados')}</p>
                    )}
                </ContentDetails>
            </div>
        </BaseTemplate>
    );
};

const mapStateToProps = state => ({
    ultimoLogRx: state.pesquisa.log[state.pesquisa.log.length - 1],
    consultaRx: state.pesquisa.consulta,
    atividadesRx: state.pageConfig.atividades,
    statusRx: state.pageConfig.status,
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
    instituicaoRx: state.instituicao.data,
});

export default connect(mapStateToProps)(DadosAcervoBiblioteca);
